import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import { Box, CircularProgress, Grid, Tooltip } from "@mui/material"
import { Control, FieldErrorsImpl } from "react-hook-form"
import { useTranslation } from "react-i18next"
import ProxyAlert from "../../ProxyAlert"
import Switch from "../../common/form/Switch"
import TextField from "../../common/form/TextField"

interface Props {
    control: Control<any, any>
    errors: Partial<FieldErrorsImpl<any>>
    error: boolean
    loading: boolean
    type: string
}
const SecondStep = ({ control, errors, error, loading, type }: Props) => {
    const { t } = useTranslation()
    return (
        <Grid item md={12}>
            {loading ? (
                <Box
                    sx={{
                        display: "flex",
                        mt: 1,
                        p: 4,
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <CircularProgress />
                </Box>
            ) : error ? (
                <>
                    <ProxyAlert
                        title={t("dataSource:proxyAlert.title")}
                        causesTitle={t("dataSource:proxyAlert.causesTitle")}
                        reasons={[
                            {
                                title: t("dataSource:proxyAlert.reasons.invalidTitle"),
                                description: t("dataSource:proxyAlert.reasons.invalidDescription"),
                            },
                            { title: t("dataSource:proxyAlert.reasons.blockedTitle") },
                        ]}
                    />
                    <Box sx={{ mt: 1 }}>
                        <Switch
                            control={control}
                            name="proxy"
                            error={errors.proxy}
                            label={
                                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                    <span>{t("dataSource:proxyAlert.switchLabel")}</span>
                                    <Tooltip title={t("dataSource:proxyAlert.switchTooltip")} arrow>
                                        <InfoOutlinedIcon fontSize="small" />
                                    </Tooltip>
                                </Box>
                            }
                        />
                    </Box>
                </>
            ) : (
                <TextField
                    control={control}
                    fullWidth
                    name="JSONdata"
                    multiline={true}
                    disabled
                    error={errors.data}
                    rows={15}
                    label={t(`dataSource:dataType.${type}`)}
                />
            )}
        </Grid>
    )
}

export default SecondStep
